import React, { useMemo } from 'react';

import { css } from '@emotion/react';
import { Skeleton } from '@mui/material';

import Table from '@components/Common/Table';

import { titleStyle } from '@styles/common';

import { PORTFOLIO_DETAIL_INVEST_LIST_HEADER } from '@constants/tableheader';

/** 포트폴리오 상세 > 투자유치이력 > 투자이력 스켈레톤 */
const PortfolioInvestListSkeleton = () => {
  /** 테이블에 노출용 데이터 세팅 */
  const tableData = useMemo(
    () =>
      Array.from({ length: 5 })?.map((_: any, i: number) => ({
        id: i,
        date: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
        level: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
        amount: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
        investor: (
          <div css={items}>
            <Skeleton variant="text" width={120} />
          </div>
        ),
      })),
    []
  );

  return (
    <>
      <div css={titleStyle}>
        <Skeleton variant="text" width={80} />
      </div>
      <div>
        <Table header={PORTFOLIO_DETAIL_INVEST_LIST_HEADER} data={tableData} />
      </div>
    </>
  );
};

export default PortfolioInvestListSkeleton;

const items = css`
  display: flex;
  justify-content: center;
`;
